<template>
  <div>
    <div class="container">
      <div class=" body-detail">
        <div class="body-detail2">
          <div class="body-detail3 asside">
            <ith-detail-asside class="" />
          </div>
          <div class="body-detail3 general">
            <ith-detail-general class="" />
          </div>
          <div
            v-if="show && show.isMovie == false && showDetail.seasons != ''"
            class="body-detail3 episodes"
          >
            <ith-detail-episodes />
          </div>
          <div
            v-if="showDetail.trailers && showDetail.trailers.length > 0"
            class="body-detail3 trailers"
          >
            <ith-detail-trailers />
          </div>
          <div
            v-if="
              showDetail.recommendations &&
                showDetail.recommendations.length > 0
            "
            class="body-detail3 recomendations"
          >
            <ith-detail-recomendations />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: mapState(["showDetail", "show"])
};
</script>

<style scoped>
.container {
  background-color: #284367;
  margin-top: -40vh;
  padding-top: 50px;
  border-radius: 50px;
}
.body-detail {
  /* position: absolute; */
  /* background-color: #284367; */
  top: 50vh;
  border-radius: 50px;
  /* margin-top: -50vh;
  z-index:top; */
}
.body-detail1 {
  margin-top: -10%;
  background-color: #284367;
}
.body-detail2 {
  display: grid;
  grid-template-columns: 25% 60%;
  justify-content: center;
  column-gap: 5%;
  grid-template-areas:
    "asside general"
    "asside episodes"
    "asside trailers"
    "asside recomendations";
}

.asside {
  grid-area: asside;
}
.general {
  grid-area: general;
}
.episodes {
  grid-area: episodes;
}
.trailers {
  grid-area: trailers;
}
.recomendations {
  grid-area: recomendations;
}

@media (min-width: 1264px) and (max-width: 1400px) {
}
@media (min-width: 1020px) and (max-width: 1264px) {
}
@media (min-width: 960px) and (max-width: 1020px) {
}
@media (min-width: 600px) and (max-width: 960px) {
  .body-detail2 {
    grid-template-columns: 27% 60%;
    column-gap: 2%;
  }
}

@media (max-width: 600px) {
  .container {
    background-color: #284367;
    margin-top: 0px;
    padding-top: 50px;
  }

  .body-detail2 {
    display: grid;
    grid-template-columns: 97%;
    grid-template-areas:
      "asside"
      "general"
      "episodes"
      "trailers"
      "recomendations";
  }
}
</style>
